export const BRAND_COLOR = "#FF3301";
export const BRAND_COLOR_HOVER = "#ff5c33";

export const easyCorsInit = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Content-Type, Authorization",
  },
};

export const IMAGE_NOT_FOUND_URL =
  "https://placehold.co/300x300?text=Not+Found";

export const DEFAULT_PRODUCTS_PAGE_SIZE = 15;
export const MAX_PRODUCTS_PAGE_SIZE = 999;
